import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';

@Component({
  selector: 'app-severity-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      *ngIf="currentSeverity; else noSeverity"
      class="px-3 py-1 rounded-full text-xs font-medium"
      [ngClass]="[
        feUtil.getSeverityColor(currentSeverity),
        currentSeverity === 'high' ? 'bg-danger/10' : '',
        currentSeverity === 'medium' ? 'bg-[#FF8D0F]/10' : '',
        currentSeverity === 'low' ? 'bg-warning/10' : ''
      ]">
      {{ currentSeverity | titlecase }}
    </span>
    <ng-template #noSeverity>
      <span class="inline-flex items-center px-2 py-0.5 font-medium">
        N/A
      </span>
    </ng-template>
  `,
})
export class SeverityChipComponent implements OnChanges {
  protected readonly feUtil = inject(FeUtil);
  protected readonly severityMapByNumber: Record<number | string, 'high' | 'medium' | 'low'> = {
    3: 'high',
    2: 'medium',
    1: 'low',
  };
  protected readonly severityMapByString: Record<string, 'high' | 'medium' | 'low'> = {
    'High': 'high',
    'Medium': 'medium',
    'Low': 'low',
  };
  @Input({ required: true, alias: 'severity' }) severity!: number | string;
  currentSeverity!: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['severity']?.currentValue) {
      if (typeof changes['severity']?.currentValue === 'number') {
        this.currentSeverity = this.severityMapByNumber[changes['severity']?.currentValue];
      } else if (typeof changes['severity']?.currentValue === 'string') {
        this.currentSeverity = this.severityMapByString[changes['severity']?.currentValue];
      }
    }
  }
}
